import React from "react";
import { Text } from "@pushpress/shared-components";
import { useAppointmentCreditsQuery } from "../../../apis/appointmentApi.hooks";

interface SessionsCreditProps {
  appointmentTypeUuid: string;
  userUuid: string;
}

function SessionsCredit(props: SessionsCreditProps) {
  const { appointmentTypeUuid, userUuid } = props;

  const appointmentCreditsQuery = useAppointmentCreditsQuery(
    userUuid,
    appointmentTypeUuid,
  );

  const credits = appointmentCreditsQuery.data?.data?.count || 0;

  return (
    <div className="mb-4">
      <Text variant="body-sm" color="wolf-600">
        REMAINING CREDITS
      </Text>
      <Text variant="heading-5">{credits > 0 ? credits : "-"}</Text>
    </div>
  );
}

export default SessionsCredit;
